<section>
   
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-sm-1"></div>
            <div class="col-sm-10 p-0">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">Home</li>
                    <li class="breadcrumb-item">Admin</li>
                    <li class="breadcrumb-item active">Client Master</li>
                </ol>
            </div>
            <div class="col-sm-1"></div>
        </div>
    </div>
</section>
<section>
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-sm-1"></div>
            <div class="col-sm-10 p-0">
                <div class="card" style="background-color: #007bff;">
                    <div class="card-header">
                        <div class="col-md-6">
                            <span class="devcare-sub-header" style="color: white;"><i class="fas fa-plus mr-1"></i>
                                Client Master</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-1"></div>
        </div>
    </div>
</section>
<section>
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-sm-1"></div>
            <div class="col-sm-10 p-0">
                <form [formGroup]="clientMasterForm">
                    <div class="card">
                        <div class="devcare-card-header">
                            <div class="p-text-bold view-header text-primary">Client Profile</div>
                        </div>
                        <div class="devcare-card-body">
                            <div class="p-fluid p-formgrid p-grid">
                                <div class="p-field p-col-12 p-md-6">
                                    <label>Client Name <span class="required-field">*</span></label>
                                    <input class="form-control" type="text"  formControlName="companyName"
                                    (keyup)="onClientNameAvailabilityCheck()"  pInputText >
                                    <span class="text-danger" *ngIf="clientNameAvail">
                                        Client name already exists
                                      </span>
                                    <!-- <span class="text-danger" *ngIf="clientMasterForm?.controls?.companyName?.hasError('required')">Client name is required</span> -->
                                    <!-- <span class="text-danger" *ngIf="clientMasterForm?.controls?.companyName?.hasError('pattern')">Please enter a valid Client Name</span> -->
                                </div>
                                <!-- <div class="p-field p-col-12 p-md-4">
                                    <label>Verify Client Name <span class="required-field">*</span></label>
                                    <input class="form-control" type="text" pInputText>
                                </div> -->
                                <div class="p-field p-col-12 p-md-6">
                                    <label>Client Short Name <span class="required-field">*</span></label>
                                    <input class="form-control" type="text" pInputText formControlName="companyShortName">
                                    <!-- <span class="text-danger" *ngIf="clientMasterForm?.controls?.companyShortName?.hasError('required')">Client short name is required</span> -->
                                    <!-- <span class="text-danger" *ngIf="clientMasterForm?.controls?.companyShortName?.hasError('pattern')">Please enter a valid Client Short Name</span> -->
                                </div>
                            </div>
                            <div class="p-fluid p-formgrid p-grid">
                                <div class="p-field p-col-12 p-md-4">
                                    <label>Client Email Id <span class="required-field">*</span></label>
                                    <input class="form-control" type="text"  formControlName="primaryEmail" (keyup)="checkEmail()"
                                    type="email" [ngClass]="{'primaryEmail':userEmailAvail}" pInputText>
                                    <span class="text-danger" *ngIf="clientMasterForm?.controls?.PrimaryEmail?.hasError('required')">Client Email Id is required</span>
                                    <span class="text-danger" *ngIf="clientMasterForm?.controls?.PrimaryEmail?.hasError('pattern')">Please enter a valid Client Email Id</span>
                                    <span class="text-danger" *ngIf="userEmailAvail">
                                        Email Address already exists
                                      </span>
                                </div>
                                <div class="p-field p-col-12 p-md-4">
                                    <label>Address Line 1 <span class="required-field">*</span></label>
                                    <input class="form-control" type="text" pInputText formControlName="addressLine1">
                                </div>
                                <div class="p-field p-col-12 p-md-4">
                                    <label>Address Line 2</label>
                                    <input class="form-control" type="text" pInputText formControlName="addressLine2">
                                </div>
                                
                            </div>
                            <div class="p-fluid p-formgrid p-grid">
                                <div class="p-field p-col-12 p-md-4">
                                    <label>Web Address</label>
                                    <input class="form-control" type="text" pInputText formControlName="webAddress">
                                </div>
                                <div class="p-field p-col-12 p-md-4">
                                    <label>Tax ID Number</label>
                                    <input class="form-control" type="text" pInputText formControlName="taxIdNumber">
                                </div>
                                <div class="p-field p-col-12 p-md-4">
                                    <label>Country</label>
                                    <p-dropdown [options]="countries" optionLabel="name" optionValue="id" [disabled]=true formControlName="countryId">
                                    </p-dropdown> 
                                </div>
                            </div>
                            <div class="p-fluid p-formgrid p-grid">
                                <div class="p-field p-col-12 p-md-3">
                                    <label>State <span class="required-field">*</span></label>
                                    <p-dropdown [options]="states" optionLabel="stateName" optionValue="stateId" formControlName="stateId"></p-dropdown>
                                </div>
                                <div class="p-field p-col-12 p-md-3">
                                    <label>City <span class="required-field">*</span></label>
                                    <input class="form-control" type="text" pInputText formControlName="city">
                                </div>
                                <div class="p-field p-col-12 p-md-3">
                                    <label>Zip Code <span class="required-field">*</span></label>
                                   
                                    <input type="text" class="form-control" formControlName="zipCode" maxlength="5"
                                    (keypress)="onlyNumbers($event)" pInputText >
                                </div>
                                <div class="p-field p-col-12 p-md-3">
                                    <label>Zip Code Ext</label>
                                    <input class="form-control" type="text" pInputText formControlName="zipCodeExt">
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="card">
                        <div class="devcare-card-header">
                            <div class="p-text-bold view-header text-primary">Admin Details</div>
                        </div>
                        <div class="devcare-card-body">
                            <div class="p-fluid p-formgrid p-grid">
                                <div class="p-field p-col-12 p-md-4">
                                    <label>First Name <span class="required-field">*</span></label>
                                    <input class="form-control" type="text" pInputText>
                                </div>
                                <div class="p-field p-col-12 p-md-4">
                                    <label>Last Name <span class="required-field">*</span></label>
                                    <input class="form-control" type="text" pInputText>
                                </div>
                                <div class="p-field p-col-12 p-md-4">
                                    <label>User Email Id <span class="required-field">*</span></label>
                                    <input class="form-control" type="text" pInputText>
                                </div>
                            </div>
                            <div class="p-fluid p-formgrid p-grid">
                                <div class="p-field p-col-12 p-md-4">
                                    <label>Phone Number</label>
                                    <input class="form-control" type="text" pInputText>
                                </div>
                                <div class="p-field p-col-12 p-md-4">
                                    <label>Extension Number</label>
                                    <input class="form-control" type="text" pInputText>
                                </div>
                            </div>
                        </div>
                    </div> -->
                </form>
            </div>
            <div class="col-sm-1"></div>
        </div>
    </div>
</section>
<section>
    <div class="row">
      <div class="col-md-1"></div>
      <div class="col-md-10">
        <!-- <button pButton pRipple type="button" label="Cancel" icon="pi pi-times"
          class="p-button-outlined p-button-danger float-right m-2 bg-primary" (click)="onCancel()"></button> -->
        <button pButton pRipple type="button" label="Save" icon="pi pi-check"
          [disabled]="!clientMasterForm.valid || clientNameAvail || userEmailAvail" (click)="save(clientMasterForm)"
          class="p-button-outlined p-button-success float-right m-2 bg-success" *ngIf="sharedService.checkPermission('Admin_Add')"></button>
      </div>
      <div class="col-md-1"></div>
    </div>
    <p-toast position="bottom-center"></p-toast>
  </section>